module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lois Duncan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lois Duncan (1934–2016) was an author of more than fifty books for young adults. Her stories of mystery and suspense have won dozens of awards and many have been named Best Books for Young Adults by the American Library Association. Among the many honors and accolades she has received for her work, in 2015, Lois Duncan was named a Grand Master by the Mystery Writers of America.  Duncan was born Lois Duncan Steinmetz in Philadelphia, Pennsylvania; she grew up in Sarasota, Florida. By age ten she was submitting her work to magazines, and she had her first story published nationally when she was just thirteen. In 1994, Duncan released a nonfiction title, "), _c('I', [_vm._v("Who Killed My Daughter?")]), _vm._v(", after her youngest child was killed in a crime that was never solved.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sjTSJ9/tc-custom/9780545388856.jpg?1705539587416",
      "alt": "This image is the cover for the book Movie for Dogs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Movie for Dogs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Andi and her canine friends are back for their biggest adventure yet—Hollywood! Third in the series starting with "), _c('i', [_vm._v("Hotel for Dogs")]), _vm._v(" (made into the hit movie).")]), _c('br'), _c('br'), _vm._v("When Andi’s brother Bruce wants to enter a dog-themed film-making contest, Andi jumps at the opportunity to become a screenwriter. But neither of them expects what happens next—a producer wants their movie! Can Andi and Bruce’s show (and dogs) go Hollywood?"), _c('br'), _c('br'), _c('b', [_vm._v("“A delightful reading experience.” —"), _c('i', [_vm._v("VOYA Magazine")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0